/* Round 11 — the subscribe option was decorative. This bridges it to Seal.

   What was wrong on the live store (measured 2026-09-12)
   -----------------------------------------------------
   The AFS2 buy box renders its own "One-time purchase" / "Subscribe & Save"
   selector. Seal Subscriptions' script also runs on the product page and rewrites
   the form: it removes the theme's selling_plan radios, leaves one hidden
   input[name="selling_plan"], and drives everything from its own
   subs_type_<hash> radios.

     click "Subscribe & Save 20%"  ->  page showed EUR 60,00
     form still submitted          ->  selling_plan="", subs_type=one_time
     what landed in the cart       ->  EUR 75.00, no selling plan

   Two traps found while fixing it
   -------------------------------
   1. [data-afs2-variants] is a SIBLING of [data-afs2-product], not a child. The
      first version of this file looked for it inside the root, found nothing and
      returned silently, so the bridge never ran at all.
   2. Seal's "subscribe" radio value is not a word — it is the plan index, "0".
      Never match on a literal; match on "anything that is not one_time".

   Round 12 (2026-09-20): respect the chosen delivery frequency
   -----------------------------------------------------------
   Every subscribe product carries TWO plans, monthly and three-monthly, but this
   file always took v.plans[0] — so every subscription silently became monthly and
   the three-month plan was unreachable. Seal's own frequency <select> is in the
   form (name="subs_interval"), just hidden along with the rest of Seal's block.
   planForCurrentVariant now reads that select and only falls back to plans[0]
   when the chosen plan is not offered on this variant.

   Approach: set Seal's own radio and fire its change event so Seal does its normal
   work, then write the selling plan id into the hidden field ourselves as a
   backstop, and re-assert both on submit because whoever writes last wins.
   Plan ids come per variant from selling_plan_allocations — a plan not allocated
   to the chosen variant is rejected by /cart/add. */
(function () {
  'use strict';

  function boot(root) {
    if (root.__afs2SealBridge) return;

    var form = root.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    // The JSON sits next to the root, inside the section. Look outward.
    var scope = root.closest('.shopify-section') || document;
    var node = scope.querySelector('[data-afs2-variants]') ||
               document.querySelector('[data-afs2-variants]');
    if (!node) return;

    var V = {};
    try { V = JSON.parse(node.textContent); } catch (e) { return; }

    root.__afs2SealBridge = true;
    var busy = false;

    function wantedPlan() {
      // Een expliciete keuze van de frequentiekiezer wint, daarna Seal's eigen
      // select, en anders niets - dan valt het terug op het eerste plan.
      var explicit = root.getAttribute('data-afs2-plan-want');
      if (explicit) return explicit;
      var sel = form.querySelector('select[name="subs_interval"]');
      if (sel && sel.value) return sel.value;
      return null;
    }

    function planForCurrentVariant() {
      var vid = form.querySelector('[name="id"]');
      var v = vid && V[String(vid.value)];
      if (!v || !v.plans || !v.plans.length) return null;
      var want = wantedPlan();
      if (want) {
        for (var i = 0; i < v.plans.length; i++) {
          if (String(v.plans[i]) === String(want)) return String(v.plans[i]);
        }
      }
      return String(v.plans[0]);
    }

    function wantsSubscription() {
      if (root.querySelector('[data-afs2-plan="sub"]:checked')) return true;
      return !!root.querySelector('.afs2-plan.is-sub-selected');
    }

    function hidden(name) {
      var el = form.querySelector('input[name="' + name + '"]');
      if (!el) {
        el = document.createElement('input');
        el.type = 'hidden';
        el.name = name;
        form.appendChild(el);
      }
      return el;
    }

    function apply() {
      if (busy) return;
      busy = true;
      try {
        var plan = wantsSubscription() ? planForCurrentVariant() : null;

        var fields = form.querySelectorAll('[name^="subs_type"]');
        for (var i = 0; i < fields.length; i++) {
          var f = fields[i];
          if (f.type === 'radio') {
            // Seal's subscribe value is the plan index ("0"), not a keyword.
            var shouldCheck = plan ? (f.value !== 'one_time') : (f.value === 'one_time');
            if (f.checked !== shouldCheck) {
              f.checked = shouldCheck;
              if (shouldCheck) f.dispatchEvent(new Event('change', { bubbles: true }));
            }
          } else {
            var target = plan ? '0' : 'one_time';
            if (f.value !== target) {
              f.value = target;
              f.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        }

        // Backstop: /cart/add reads this field, whatever Seal's UI decided.
        hidden('selling_plan').value = plan || '';
      } finally {
        busy = false;
      }
    }

    root.addEventListener('click', function (e) {
      var lbl = e.target.closest && e.target.closest('.afs2-plan');
      if (!lbl || !root.contains(lbl)) return;
      var all = root.querySelectorAll('.afs2-plan');
      for (var i = 0; i < all.length; i++) all[i].classList.remove('is-sub-selected');
      if (lbl.querySelector('[data-afs2-plan="sub"]') || /subscribe/i.test(lbl.textContent)) {
        lbl.classList.add('is-sub-selected');
      }
      setTimeout(apply, 0);
    });

    root.addEventListener('change', function () { setTimeout(apply, 0); });

    // Last word before the request leaves, for both the real submit and the
    // theme's own fetch-based add.
    form.addEventListener('submit', apply, true);
    var addBtn = root.querySelector('[data-afs2-add]');
    if (addBtn) addBtn.addEventListener('click', apply, true);
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-afs2-sticky-add]')) apply();
    }, true);

    // De frequentiekiezer laat dit weten via een event op de root.
    root.addEventListener('afs2:plan-change', function () { setTimeout(apply, 0); });

    apply();
  }

  function init() {
    var roots = document.querySelectorAll('[data-afs2-product]');
    for (var i = 0; i < roots.length; i++) boot(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  // Seal and the theme editor both re-render the buy box after load.
  document.addEventListener('shopify:section:load', init);
  setTimeout(init, 1200);
  setTimeout(init, 3000);
})();